<template>

    <div class="position-relative section-margin-bottom" v-for="activity in activities" :key="activity.id">

      <h2  class="is-1  mb-6">{{ activity.title }}</h2>


    <div class="level-group-info mb-6">

      <q-checkbox size="xs" v-model="activity.onOffCampus.individually" val="xs" label="Individually" />

      <q-checkbox size="xs" v-model="activity.onOffCampus.pairs" val="xs" label="Pairs" />

      <q-checkbox size="xs" v-model="activity.onOffCampus.groups" val="xs" label="Groups" />

      <q-checkbox size="xs" v-model=" activity.onOffCampus.online" val="xs" label="Online" />

      <q-checkbox size="xs" v-model=" activity.onOffCampus.onCampus" val="xs" label="Campus" />

    </div>  
    
    <q-list  class="accordian-container">

            <q-expansion-item
        class="description"
        icon="help"
        label="Description"
        default-opened
        header-class="text-primary"
        popup
      >
        <q-card>
          <q-card-section v-html="activity.description">
          
          </q-card-section>
        </q-card>
      </q-expansion-item>


            <q-expansion-item
        default-opened
        class="resources"
        icon="build"
        label="Resources"
        header-class="text-primary"
        popup
      >
        <q-card>
          <q-card-section v-html="activity.resources">
          
          </q-card-section>
        </q-card>
      </q-expansion-item>

        <q-expansion-item
        v-if="activity.onCampusNotesDisplay === true"
        default-opened
        icon="business"
        label="On campus notes"
        header-class="text-primary"
        popup
      >
        <q-card>
          <q-card-section v-html="activity.onCampusNotes">
          
          </q-card-section>
        </q-card>
      </q-expansion-item>

       
    </q-list>
  </div>
</template>

<script>

import getPosts from "../composables/getposts"

export default {
    props: ['activities'],
    setup() {
      const {posts} = getPosts()
      
      return{ posts }
    },
}
</script>

<style lang="scss" >
  .resources, .description  {

    & ul {
      margin-left: 1.5rem;

    }
    
    &, ul li {
      list-style: square;
      font-size: 1.9rem;
    }
  }
</style>
